import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { GroupGoalsLoadAction } from '../../domains/groupGoals/actions.types';

import { Goals } from './types';

export const initialState: Goals = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<Goals, GroupGoalsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_GOALS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.goals);
    default:
      return state;
  }
};

export default reducer;
